import { render, staticRenderFns } from "./jmOrderDetail2022.vue?vue&type=template&id=049a1a9e&"
import script from "./jmOrderDetail2022.vue?vue&type=script&lang=js&"
export * from "./jmOrderDetail2022.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports